import { defineStore, storeToRefs } from 'pinia';
import { writeToClipboardApi } from '@/helpers/copyToClipboard';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { useEditor } from '@/stores/editor/editor';
import { useTracking } from '@/stores/tracking/tracking';
import { ref } from 'vue';

export const useDocumentAtsLink = defineStore('documentAtsLink', () => {
  const { editorLinkClick } = useTracking();

  const windowRef = ref(window);
  const setWindow = (wnd) => {
    windowRef.value = wnd;
  };

  const {
    atsEditUrl,
    projectIntegrationType,
    tapwageId,
  } = storeToRefs(useEditor());

  const openAtsLink = () => {
    editorLinkClick({ label: `Open in ${projectIntegrationType.value}` });
    windowRef.value.open(atsEditUrl.value, '_blank', 'noopener,noreferrer');
  };

  const copyAtsLink = () => {
    editorLinkClick({ label: `Copy URL to ${projectIntegrationType.value}}` });
    writeToClipboardApi(atsEditUrl.value);

    useAppSnackbar().addSuccessSnackbar({
      text: `${projectIntegrationType.value} URL successfully copied to clipboard`,
      timeout: 3500,
    });
  };

  const openTapwageLink = () => {
    editorLinkClick({ label: 'View on Tapwage' });
    windowRef.value.open(`/redirect/tapwage/${tapwageId.value}`, '_blank', 'noopener,noreferrer');
  };

  const openJobBoardLink = () => {
    editorLinkClick({ label: 'View on Job Board' });
    windowRef.value.open(`/redirect/external?id=${tapwageId.value}`, '_blank', 'noopener,noreferrer');
  };

  return {
    copyAtsLink,
    openAtsLink,
    openJobBoardLink,
    openTapwageLink,
    setWindow,
  };
});
